// 空状态生成器：餐饮卡（meal/restaurant）
export function createEmptyMealPayload() {
  return {
    card_type: 'restaurant',
    type: 'restaurant',
    title: '请输入餐厅名称',
    imageUrl: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200&h=600&fit=crop&auto=format',
    address: '请填写餐厅地址',
    addressIcon: '📍',
    restaurantIcon: '🍴',
    description: '请填写餐厅的描述',
    metaPairs: [],
    tags: [],
    card: {},
  };
}
